// 9 digits total, optional dashes, no all zeros in any one group
export const ssnRegex = /^(?!000)\d{3}-?(?!00)\d{2}-?(?!0000)\d{4}$/u;

export function isSsn(ssnish: string) {
  return ssnRegex.test(ssnish);
}

export function isValidSsn(value: string): boolean {
  const digits = value.replace(/\D/gu, '');
  if (!/^\d{9}$/u.test(digits)) return false;

  const area = digits.slice(0, 3);
  const group = digits.slice(3, 5);
  const serial = digits.slice(5);

  // Area number (first 3): not 000, 666, or 900-999
  if (area === '000' || area === '666' || Number(area) >= 900) return false;
  // Group number (middle 2): not 00
  if (group === '00') return false;
  // Serial number (last 4): not 0000
  if (serial === '0000') return false;
  // Repetitive: all nine digits identical (000-00-0000 ... 999-99-9999)
  if (/^(\d)\1{8}$/u.test(digits)) return false;
  // Known full sequential patterns
  if (
    digits === '123456789' ||
    digits === '987654321' ||
    digits === '876543210' ||
    digits === '012345678'
  )
    return false;

  return true;
}

export const obfuscateSsn = (ssn: string | null | undefined) => {
  if (!ssn) {
    return null;
  }

  const ssnNoDashes = ssn.replaceAll('-', '');
  const visiblePart = ssnNoDashes.slice(-4);
  return visiblePart.padStart(ssnNoDashes.length, 'X');
};

export const formatSsn = (ssn: string | null | undefined): string => {
  if (!ssn) return '';

  const digits = ssn.replace(/-/gu, '');

  if (digits.length < 6) {
    return digits.length > 3
      ? `${digits.substring(0, 3)}-${digits.substring(3)}`
      : digits;
  }

  return `${digits.substring(0, 3)}-${digits.substring(3, 5)}-${digits.substring(5)}`;
};

export const obfuscateAndFormatSsn = (
  ssn: string | null | undefined
): string | undefined => {
  if (!ssn) {
    return undefined;
  }
  return formatSsn(obfuscateSsn(ssn));
};

export const normalizeAndSetSSN = (
  ssn: string | null,
  setSsnValue: (value: string) => void
) => {
  if (!ssn) {
    setSsnValue('');
    return;
  }

  const digitsOnlySSN = ssn.replace(/\D/gu, '').substring(0, 9);
  setSsnValue(digitsOnlySSN);
};
